<template>
    <div v-if="showDialog" class="modal flex-container" @click.self="$emit('close')">
        <div class="modal-content vertical" :style="style">
            <div class="modal-slot">
                <div style="margin: 0 40px; border-bottom: 0.5px solid #AEAEAE;">
                    <div class="header-cookies">
                        Cookie Settings
                    </div>
                    <div>
                        <p class="cookies-context">BioControl asks you to accept service performance cookies. For more information or to adjust your settings, please click the "More Information" button or select "Cookie Settings" at the bottom of the site. More information about cookies and the processing of personal data can be found in the Privacy Policy and Cookie Policy. Do you accept these cookies and the related processing of personal data?</p>
                    </div>
                    <div class="horizontal" style="justify-content: space-around; margin-bottom: 25px;">
                        <button class="button-settings" @click="moreInfo">More Informations</button>
                        <button class="button-agree" @click="accept">Apply</button>
                    </div>
                </div>
                <div style="margin: 20px 40px 0 40px;">
                    <p class="cookies-context" style="font-size: 12px;">You can change your settings at any time by going to <a href="https://support.google.com/chrome/answer/95647" target="_blank">this page</a>. <b>For details, please refer to the GDPR Privacy Policy and Cookie Policy.</b></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: ['showDialog', 'maxWidth', 'title'],
    watch: {
        showDialog: function(newVal, oldVal) {
        },
    },
    methods: {
        accept() {
            this.$store.dispatch('update_cookies', true)
        },
        moreInfo() {

        }
    },
    components: {
    },
    computed: {
        style () {
            return 'max-width: ' + this.maxWidth;
        }
    },
    mounted: function () {
    },
    data() {
        return {
        }
    },
    created() {
    }
}
</script>

<style scoped>
.modal {
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    display: block;
    background-color: rgba(0,0,0,0.4);
}

.flex-container {
    height: 100%;
    padding: 0;
    margin: 0;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border: 1px solid #888;
    width: auto;
    z-index: 1000;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0,0,0,0.2);
}

.modal-header {
    background-color:  #34758E;
    width: 100%;
    font-family: "SourceSansProBold", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: white;
}

.close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.widthClass {
    max-width: 30%;
}

.modal-slot {
    max-width: 400px;
    /* margin-right: 10px;
    margin-left: 10px; */
}

#mdiv {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: white;
  transform: rotate(45deg);
  Z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: white;
  transform: rotate(90deg);
  Z-index: 2;
}

.button-agree {
    color: white;
    background: #617590;
    border: 1px solid #617590;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 16px;
    padding: 10px 20px;
}

.button-settings {
    padding: 5px 10px;
    color: #617590;
    border: 1px solid #617590;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 16px;
}

.header-cookies {
    margin-top: 60px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 30px;

    color: #272727;
}

.cookies-context {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 118.69%;
    color: #272727;
    margin-bottom: 20px;
    letter-spacing: 0.05em;
}
</style>



// WEBPACK FOOTER //
// src/components/CookiesModal.vue